export var CurrentConnectionEvents;
(function (CurrentConnectionEvents) {
    CurrentConnectionEvents["ScreenShareStatus"] = "screenShareStatus";
    CurrentConnectionEvents["VideoStatus"] = "videoStatus";
    CurrentConnectionEvents["AudioSubscribers"] = "audioSubscribers";
    CurrentConnectionEvents["VideoSubscribers"] = "videoSubscribers";
    CurrentConnectionEvents["ScreenShareTracks"] = "screenShareTracks";
})(CurrentConnectionEvents || (CurrentConnectionEvents = {}));
